import {lazy} from './lazy.js';
import {WIDTH, HEIGHT} from 'components/effects/plane/constants.js';
import {doc} from './documentation.js';

doc(
    "translate",
    {
        "x": "",
        "y": "",
    },
    "Translate parameters by (x,y) amount"
);

export const translate = (x,y) => {
    return (...args) => {
        let _x = lazy(x, ...args);
        let _y = lazy(y, ...args);
        let coords = args[0];
        let _coords = {};
        for (let key in coords) {
            if (!coords[key]) {
                continue;
            }
            let xDiff = _x / (coords[key].density || 1);
            let yDiff = _y / (coords[key].density || 1);
            _coords[key] = {
                ... coords[key],
                x: (coords[key].x + xDiff) % WIDTH,
                y: (coords[key].y + yDiff) % HEIGHT,
            };
        }
        return _coords;
    };
};
